import {
  Document,
} from '../../../../types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetDictationOperation extends SynchronousDocumentOperation {
  readonly type = 'set-dictation';

  isEnabled: boolean;

  constructor(documentId: string, isEnabled: boolean) {
    super(documentId);
    this.isEnabled = isEnabled;
  }

  apply(document: Document): Document {
    return {
      ...document,
      meta: {
        ...document.meta,
        hasDictation: this.isEnabled,
      },
    };
  }
}
